import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "../../editableProps";
import Toggle from "@builder/components/general/Toggle";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { EOSNode } from "@common/build/types";
import "./style.scss";
import { updateEOSSettings } from "@builder/store/slices/BuilderSlice/builderSlice";

const EOSData: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    const selectedNode = useAppSelector(getSelectedNode) as EOSNode;
    const dispatch = useAppDispatch();

    enum EOSSettingsType {
        showSessionSummary = "showSessionSummary",
        showPaymentBreakdown = "showPaymentBreakdown",
        showCashDrawer = "showCashDrawer",
        showFloatAdjustment = "showFloatAdjustment",
        showTaxBreakdown = "showTaxBreakdown",
        showRefunds = "showRefunds",
        showStaffBreakdown = "showStaffBreakdown",
        showDiscount = "showDiscount",
        showClosingNotes = "showClosingNotes"
    }

    const handleToggle = (val: boolean, type?: EOSSettingsType) => {
        dispatch(
            updateEOSSettings({
                type: type || "",
                setting: val
            })
        );
    };

    return (
        <SidebarCollapse title="EOS" parent={parent}>
            <div className="eos-data-options-wrapper">
                <Toggle label="Show session summary" checked={selectedNode.settings.showSessionSummary} callback={v => handleToggle(v, EOSSettingsType.showSessionSummary)} />
                <Toggle label="Show payment breakdown" checked={selectedNode.settings.showPaymentBreakdown} callback={v => handleToggle(v, EOSSettingsType.showPaymentBreakdown)}  />
                <Toggle label="Show cash drawer" checked={selectedNode.settings.showCashDrawer} callback={v => handleToggle(v, EOSSettingsType.showCashDrawer)}  />
                <Toggle label="Show float adjustment" checked={selectedNode.settings.showFloatAdjustment} callback={v => handleToggle(v, EOSSettingsType.showFloatAdjustment)}  />
                <Toggle label="Show tax breakdown" checked={selectedNode.settings.showTaxBreakdown} callback={v => handleToggle(v, EOSSettingsType.showTaxBreakdown)} />
                <Toggle label="Show refunds" checked={selectedNode.settings.showRefunds} callback={v => handleToggle(v, EOSSettingsType.showRefunds)}  />
                <Toggle label="Show staff breakdown" checked={selectedNode.settings.showStaffBreakdown} callback={v => handleToggle(v, EOSSettingsType.showStaffBreakdown)} />
                <Toggle label="Show discounts" checked={selectedNode.settings.showDiscount} callback={v => handleToggle(v, EOSSettingsType.showDiscount)} />
                <Toggle label="Show closing notes" checked={selectedNode.settings.showClosingNotes} callback={v => handleToggle(v, EOSSettingsType.showClosingNotes)}/>
            </div>
        </SidebarCollapse>
    );
};

export default EOSData;